import { ReactElement } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { WarningNotification } from 'components/WarningNotification'
import { saleChannelMessages } from 'features/Bookings/components/SaleChannel/messages'
import { GTTripV2ConfirmationModalitySalesChannel } from 'gql/types.generated'
import { safeFormatMessage } from 'utils/intl'

interface IImpactedSalesChannelsNotificationProps {
  salesChannels: GTTripV2ConfirmationModalitySalesChannel[]
}

export const ImpactedSalesChannelsNotification = ({
  salesChannels
}: IImpactedSalesChannelsNotificationProps): ReactElement => {
  const intl = useIntl()

  return (
    <WarningNotification>
      <FormattedMessage
        id="trips.changeModality.warning"
        defaultMessage="You are impacting the {salesChannels} {salesChannelsCount, plural,
          one {sales channel}
          other {sales channels}
        }"
        values={{
          salesChannels: salesChannels.map(({ name }, index) => {
            return (
              <>
                <strong key={index}>{safeFormatMessage({ intl, messages: saleChannelMessages, key: name })}</strong>
                {index < salesChannels.length - 2 && ', '}
                {index === salesChannels.length - 2 && ' and '}
              </>
            )
          }),
          salesChannelsCount: salesChannels.length || 0
        }}
      />
    </WarningNotification>
  )
}
